import { render, staticRenderFns } from "./ModalEditForm.vue?vue&type=template&id=72acd6c6"
import script from "./ModalEditForm.vue?vue&type=script&lang=js"
export * from "./ModalEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports